const tor = [{
    "Team": "TOR",
    "Player": "Kawhi Leonard",
    "MP": 243,
    "TRB": 59,
    "AST": 25,
    "STL": 12,
    "BLK": 7,
    "TOV": 18,
    "PTS": 171,
    "ptsg": 30.5,
    "trb": 9.1,
    "ast": 3.9,
    "image_path": "images/kawhi-leonard.jpg"
  },
  {
    "Team": "TOR",
    "Player": "Pascal Siakam",
    "MP": 241,
    "TRB": 45,
    "AST": 22,
    "STL": 3,
    "BLK": 4,
    "TOV": 9,
    "PTS": 119,
    "ptsg": 19.0,
    "trb": 7.1,
    "ast": 2.8,
    "image_path": "images/pascal-siakam.jpg"
  },
  {
    "Team": "TOR",
    "Player": "Kyle Lowry",
    "MP": 229,
    "TRB": 24,
    "AST": 43,
    "STL": 10,
    "BLK": 3,
    "TOV": 15,
    "PTS": 97,
      "ptsg": 15.0,
      "trb": 6.6,
      "ast": 4.9,
      "image_path": "images/kyle-lowry.jpg"
  },
  {
    "Team": "TOR",
    "Player": "Fred VanVleet",
    "MP": 195,
    "TRB": 16,
    "AST": 13,
    "STL": 7,
    "BLK": 0,
    "TOV": 6,
    "PTS": 84,
      "ptsg": 8.0,
      "trb": 1.8,
      "ast": 2.6,
      "image_path": "images/fred-vanvleet.jpg"
  },
  {
    "Team": "TOR",
    "Player": "Marc Gasol",
    "MP": 173,
    "TRB": 44,
    "AST": 16,
    "STL": 3,
    "BLK": 2,
    "TOV": 7,
    "PTS": 72,
      "ptsg": 9.4,
      "trb": 6.4,
      "ast": 3.0,
      "image_path": "images/marc-gasol.jpg"
  },
  {
    "Team": "TOR",
    "Player": "Serge Ibaka",
    "MP": 116,
    "TRB": 31,
    "AST": 6,
    "STL": 5,
    "BLK": 10,
    "TOV": 8,
    "PTS": 68,
      "ptsg": 9.4,
      "trb": 6.0,
      "ast": 0.9,
      "image_path": "images/serge-ibaka.jpg"
  },
  {
    "Team": "TOR",
    "Player": "Danny Green",
    "MP": 163,
    "TRB": 21,
    "AST": 7,
    "STL": 7,
    "BLK": 3,
    "TOV": 8,
    "PTS": 44,
      "ptsg": 6.9,
      "trb": 3.6,
      "ast": 1.1,
      "image_path": "images/danny-green.jpg"
  },
  {
    "Team": "TOR",
    "Player": "Norman Powell",
    "MP": 66,
    "TRB": 6,
    "AST": 4,
    "STL": 2,
    "BLK": 0,
    "TOV": 2,
    "PTS": 11,
      "ptsg": 6.5,
      "trb": 2.2,
      "ast": 1.1,
      "image_path": "images/norman-powell.jpg"
  // },
  // {
  //   "Team": "TOR",
  //   "Player": "Patrick McCaw",
  //   "MP": 12,
  //   "TRB": 0,
  //   "AST": 2,
  //   "STL": 0,
  //   "BLK": 0,
  //   "TOV": 0,
  //   "PTS": 3
  // },
  // {
  //   "Team": "TOR",
  //   "Player": "Jeremy L",
  //   "MP": 1,
  //   "TRB": 0,
  //   "AST": 0,
  //   "STL": 0,
  //   "BLK": 0,
  //   "TOV": 0,
  //   "PTS": 0
  // },
  // {
  //   "Team": "TOR",
  //   "Player": "Jodie Meeks",
  //   "MP": 1,
  //   "TRB": 0,
  //   "AST": 0,
  //   "STL": 0,
  //   "BLK": 0,
  //   "TOV": 0,
  //   "PTS": 0
  // },
  // {
  //   "Team": "TOR",
  //   "Player": "Malcolm Miller",
  //   "MP": 1,
  //   "TRB": 0,
  //   "AST": 0,
  //   "STL": 0,
  //   "BLK": 0,
  //   "TOV": 0,
  //   "PTS": 0
  // },
  // {
  //   "Team": "TOR",
  //   "Player": "Team Totals",
  //   "MP": 1440,
  //   "TRB": 246,
  //   "AST": 138,
  //   "STL": 49,
  //   "BLK": 29,
  //   "TOV": 73,
  //   "PTS": 669
  }]

const gsw =
  [{
        "Team": "GSW",
        "Player": "Stephen Curry",
        "MP": 250,
        "TRB": 31,
        "AST": 36,
        "STL": 9,
        "BLK": 1,
        "TOV": 17,
        "PTS": 183
    },
    {
        "Team": "GSW",
        "Player": "Klay Thompson",
        "MP": 188,
        "TRB": 24,
        "AST": 12,
        "STL": 4,
        "BLK": 0,
        "TOV": 6,
        "PTS": 130
    },
    {
        "Team": "GSW",
        "Player": "Draymond Green",
        "MP": 248,
        "TRB": 65,
        "AST": 56,
        "STL": 10,
        "BLK": 6,
        "TOV": 30,
        "PTS": 75
    },
    {
        "Team": "GSW",
        "Player": "Andre Iguodala",
        "MP": 188,
        "TRB": 27,
        "AST": 24,
        "STL": 6,
        "BLK": 9,
        "TOV": 9,
        "PTS": 55
    },
    {
        "Team": "GSW",
        "Player": "DeMarcus Cousins",
        "MP": 108,
        "TRB": 28,
        "AST": 14,
        "STL": 4,
        "BLK": 6,
        "TOV": 13,
        "PTS": 50
    },
    {
        "Team": "GSW",
        "Player": "Quinn Coo",
        "MP": 88,
        "TRB": 5,
        "AST": 5,
        "STL": 1,
        "BLK": 1,
        "TOV": 2,
        "PTS": 29
    },
    {
        "Team": "GSW",
        "Player": "Kevon Looney",
        "MP": 104,
        "TRB": 16,
        "AST": 6,
        "STL": 2,
        "BLK": 1,
        "TOV": 5,
        "PTS": 29
    },
    {
        "Team": "GSW",
        "Player": "Shaun Livingston",
        "MP": 98,
        "TRB": 9,
        "AST": 9,
        "STL": 4,
        "BLK": 1,
        "TOV": 5,
        "PTS": 28
    },
    {
        "Team": "GSW",
        "Player": "Jonas Jerebko",
        "MP": 26,
        "TRB": 5,
        "AST": 1,
        "STL": 0,
        "BLK": 0,
        "TOV": 0,
        "PTS": 14
    },
    {
        "Team": "GSW",
        "Player": "Alfonzo McKinnie",
        "MP": 57,
        "TRB": 10,
        "AST": 2,
        "STL": 0,
        "BLK": 0,
        "TOV": 3,
        "PTS": 13
    },
    {
        "Team": "GSW",
        "Player": "Andrew Bogut",
        "MP": 45,
        "TRB": 15,
        "AST": 3,
        "STL": 1,
        "BLK": 1,
        "TOV": 2,
        "PTS": 12
    },
    {
        "Team": "GSW",
        "Player": "Kevin Durant",
        "MP": 12,
        "TRB": 2,
        "AST": 0,
        "STL": 0,
        "BLK": 1,
        "TOV": 1,
        "PTS": 11
    },
    {
        "Team": "GSW",
        "Player": "Jordan Bel",
        "MP": 25,
        "TRB": 5,
        "AST": 1,
        "STL": 0,
        "BLK": 2,
        "TOV": 0,
        "PTS": 6
    },
    {
        "Team": "GSW",
        "Player": "Jacob Evans",
        "MP": 2,
        "TRB": 0,
        "AST": 0,
        "STL": 0,
        "BLK": 0,
        "TOV": 0,
        "PTS": 0
    },
    {
        "Team": "GSW",
        "Player": "Damian Jones",
        "MP": 2,
        "TRB": 0,
        "AST": 0,
        "STL": 0,
        "BLK": 0,
        "TOV": 0,
        "PTS": 0
    },
    {
        "Team": "GSW",
        "Player": "Team Totals",
        "MP": 1440,
        "TRB": 242,
        "AST": 169,
        "STL": 41,
        "BLK": 29,
        "TOV": 93,
        "PTS": 635
    }
]

export default tor;